export default __webpack_public_path__ + "static/media/invoices-small.3a0687a1.svg";